import { createApp, h } from 'vue'
import router from '../router/index'
import { addUnit } from '@/utils'
import { setCommonApp } from '@Utils/setCommonApp'
import { BdDialog, BdButton, BdTooltip } from '@bilibili-business/bili-design'

const noop = () => {}
const sizes = {
  small: 320,
  middle: 480,
  large: 720
}
function dialog(options) {
  const {
    width,
    title = '',
    titleRender,
    size = 'default',
    render,
    component,
    okText = '确定',
    cancelText = '取消',
    customClass = '',
    closeOnClickModal = false,
    showClose = true,
    lockScroll = false,
    fullscreen = false,
    footerHide = false,
    appendToBody = true,
    closeOnPressEscape = true,
    modal = true,
    top = '15vh',
    beforeClose,
    center = false,
    destroyOnClose = false,
    zIndex,
    footerAlign = 'right',
    footerClass = 'mt10'
  } = options
  const props = {
    title,
    width,
    customClass,
    closeOnClickModal,
    showClose,
    lockScroll,
    fullscreen,
    appendToBody,
    closeOnPressEscape,
    modal,
    top,
    beforeClose,
    center,
    destroyOnClose,
    'z-index': zIndex
  }

  const container = document.createElement('div')
  document.body.appendChild(container)
  const instance = createApp({
    name: 'BizElDialog',
    router,
    data: () => {
      return {
        loading: false,
        visible: true,
        disabled: false,
        width: width === undefined ? sizes[size] || sizes.default : width,
        title
      }
    },
    created() {
      this.visible = true
    },
    methods: {
      onOk(data) {
        options.onOk && options.onOk(data)
        this.destroy()
      },
      onCancel() {
        options.onCancel && options.onCancel()
        this.destroy()
      },
      destroy() {
        this.loading = false
        instance.unmount()
        document.body.contains(container) && document.body.removeChild(container)
        this.visible = false
      }
    },
    render() {
      let footer = null
      if (!footerHide) {
        const btns = options.buttons || [
          {
            id: 'cancel',
            name: cancelText
          },
          {
            id: 'ok',
            name: okText,
            type: 'primary'
          }
        ]
        footer = h(
          'div',
          {
            class: footerClass,
            style: {
              textAlign: footerAlign
            }
          },
          btns.map(item => {
            if (item.hasHoverOuter) {
              return h(
                BdButton,
                {
                  type: item.type,
                  size: 'large',
                  ghost: item.id === 'cancel' || item.ghost,
                  disabled: item.id === 'ok' ? item.disabled : false,
                  loading: item.id === 'ok' ? this.loading : false
                },
                {
                  default: () => [
                    h(
                      BdTooltip,
                      {
                        content: item.content,
                        effect: 'light'
                      },
                      {
                        default: () => [h('span', {}, item.name)]
                      }
                    )
                  ]
                }
              )
            } else {
              return h(
                BdButton,
                {
                  type: item.type,
                  key: item.type,
                  size: 'large',
                  ghost: item.id === 'cancel' || item.ghost,
                  disabled: item.id === 'ok' ? this.disabled : false,
                  loading: item.id === 'ok' ? this.loading : false,
                  class: {
                    group: btns.length > 1
                  },
                  onClick: () => {
                    const { id } = item || {}
                    const name = `on${id[0].toUpperCase()}${id.substr(1)}`
                    if (id === 'ok' && this.$refs.dialogBody && this.$refs.dialogBody.confirm) {
                      this.loading = true
                      const func = this.$refs.dialogBody.confirm()
                      if (func && func.then) {
                        return func
                          .then(data => (options.onOk ? options.onOk(data) : noop()))
                          .then(() => this.destroy())
                          .catch(() => {
                            this.loading = false
                          })
                      } else {
                        options.onOk ? options.onOk(func) : noop()
                        this.destroy()
                        return
                      }
                    }
                    const callback = (options[name] || noop)()

                    if (!callback || !callback.then) {
                      return this.destroy()
                    }

                    this.loading = true
                    callback
                      .then(() => this.destroy())
                      .catch(() => {
                        this.loading = false
                      })
                  }
                },
                {
                  default: () => item.name
                }
              )
            }
          })
        )
      }
      return h(
        BdDialog,
        {
          ...props,
          class: props.customClass,
          width: addUnit(this.width),
          modelValue: this.visible,
          onClose: this.onCancel,
          onCancel: this.onCancel,
          onOk: this.onOk,
          // vue3 backup，both are working as 'ok' ans 'on-ok
          onOnClose: this.onCancel,
          onOnCancel: this.onCancel,
          onOnOk: this.onOk
        },
        {
          header: () => (titleRender === undefined ? h('span', { class: 'bd-dialog__title' }, title) : titleRender(h)),
          default: props =>
            component === undefined
              ? h(
                  'div',
                  {},
                  {
                    default: () => [render(h)]
                  }
                )
              : h(
                  'div',
                  {},
                  {
                    default: () => [
                      h(component, {
                        ref: 'dialogBody',
                        ...options.props,
                        onDisabled: val => {
                          this.disabled = !!val
                        },
                        onCancel: this.onCancel,
                        onOk: this.onOk
                      })
                    ]
                  }
                ),
          footer: options.footerHide ? null : () => footer
        }
      )
    }
  })
  setCommonApp(instance)
  instance.mount(container)

  return instance
}
export function open(options) {
  return dialog(options)
}
export function alert(options) {
  const contentRender = h => h('div', options.content || '')
  const render = options.render || contentRender
  return dialog({
    ...options,
    render,
    buttons: [
      {
        id: 'ok',
        name: options.okText || '确定',
        type: 'primary'
      }
    ]
  })
}
export function confirm(options) {
  const contentRender = h => h('div', {}, options.content || '')
  const render = options.render || contentRender
  return dialog({
    width: '340px',
    ...options,
    render
  })
}
const $elDialog = {
  open,
  alert,
  confirm
}
export const elDialogPlugin = {
  install: (app, options) => {
    app.provide('BizElDialog', $elDialog)
    app.config.globalProperties.$elDialog = $elDialog
  }
}
// 选项式用this.$elDialog.open，组合式用usePluginElDialog().open
export const usePluginElDialog = () => {
  return $elDialog
}
export function confirmNext(options) {
  return dialog({
    width: '546px',
    ...options
  })
}
